import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-16 px-4 bg-blue-900 text-white relative overflow-hidden" data-id="element-42">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:16px_16px]" data-id="element-43"></div>

      <div className="max-w-3xl mx-auto relative z-10 text-center" data-id="element-44">
        {/* Shield Icon */}
        <div className="flex justify-center mb-6" data-id="element-45">
          <div className="w-20 h-20 rounded-full bg-transparent border-4 border-orange-500 flex items-center justify-center" data-id="element-46">
            <ShieldCheck className="w-10 h-10 text-orange-500" strokeWidth={2.5} data-id="element-47" />
          </div>
        </div>

        {/* Title */}
        <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-48">
          Garantía sin vueltas
        </h2>

        {/* Description */}
        <div className="space-y-4 text-lg text-blue-100" data-id="element-49">
          <p className="leading-relaxed" data-id="element-50">
            Estamos tan seguros de que este Programa te va a encantar, que si no
            es así, te devolvemos el 100% de tu dinero.
          </p>
          <p className="leading-relaxed" data-id="element-51">
            Tenés 7 días para probarlo sin riesgo. Si no te convence, nos
            escribís y te hacemos el reembolso. Así de simple.
          </p>
        </div>
      </div>
    </section>;
}